import React, {useState} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import Swal from "sweetalert2";



function ModalDisputas({reserva, quienEs}){

    // variables modal
    const [show, setShow] = useState(false);
    const [descripcion, setDescripcion] = useState("");
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const contraparte = quienEs === "Vendedor" ? "comprador" : "vendedor";
    

    
    async function abrirDisputa(){
        try{
            const textoDescripcion = descripcion.trim();

            if (textoDescripcion.length < 10) {
                await Swal.fire({
                    icon: "info",
                    title: "Cuéntanos qué ocurrió",
                    text: "Por favor escribe una descripción más clara de lo sucedido.",
                    customClass: {
                        popup: 'mi-modal',
                        confirmButton: 'mi-boton-confirmar',
                        cancelButton: 'mi-boton-cancelar'
                    }
                });
                return;
            }

            const resConfir = await axios.post("/abrir-disputa", {
                params: { idReserva: reserva?._id, quienEs, descripcion: textoDescripcion }
            });

            if (!resConfir?.data?.exito) {
                await Swal.fire({
                    icon: "error",
                    title: "No fue posible abrir el reclamo",
                    text: resConfir?.data?.mensaje || "Intenta nuevamente.",
                    customClass: {
                        popup: 'mi-modal',
                        confirmButton: 'mi-boton-confirmar',
                        cancelButton: 'mi-boton-cancelar'
                    }
                });
                return;
            }

            await Swal.fire({
                icon: "success",
                title: "Reclamo enviado",
                text: "Hemos recibido tu reclamo. Revisaremos la reserva y nos pondremos en contacto contigo.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
            window.location.reload();
            return
        }
        catch(err){
            await Swal.fire({
                icon: "error",
                title: "Error al abrir reclamo",
                text: err?.response?.data?.mensaje || "No fue posible abrir el reclamo. Intenta nuevamente.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
        }
    }
 

    return(
        <div>
        <Button className="w-100 mt-3 rounded-pill fw-semibold" variant="outline-danger" onClick={handleShow}>
            <i className="bi bi-exclamation-circle me-2"></i>
            Presentar un reclamo
        </Button>

        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold text-dark">
                    Presentar un reclamo
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                    <div className="text-center mb-4">
                        <div className="mb-3">
                            <i className="bi bi-exclamation-triangle text-danger" style={{ fontSize: "2.4rem" }}></i>
                        </div>

                        <h5 className="fw-bold mb-2">Lamentamos que tengas que presentar un reclamo</h5>

                        <p className="text-muted mb-0">
                            Por favor llena el formulario con todo lo que sucedió. Nos pondremos en contacto contigo y con el {contraparte} para poder encontrar una solución.
                        </p>
                    </div>

                    <div className="alert alert-warning border-0 rounded-4 small mb-3" role="alert">
                        <div className="fw-semibold mb-1">
                            <i className="bi bi-exclamation-triangle me-2"></i>
                            Importante
                        </div>
                        Usaremos toda la información de la reserva y el chat para llegar a una solución. Por el momento, retendremos el pago al vendedor hasta que el caso sea solucionado.
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold small">Cuéntanos qué sucedió</label>
                        <textarea
                            className="form-control rounded-4"
                            rows="5"
                            maxLength="1200"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            placeholder="Describe con el mayor detalle posible qué ocurrió con el servicio..."
                        />
                        <div className="text-end text-muted small mt-1">
                            {descripcion.length}/1200
                        </div>
                    </div>

                    <button onClick={abrirDisputa} className="btn btn-danger rounded-pill w-100 fw-semibold py-2">
                        <i className="bi bi-send me-2"></i>
                        Enviar reclamo
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    </div>
    );

}



export default ModalDisputas;